module.exports = __webpack_public_path__ + "img/mong.9fc24ac1.png";